// frontend/src/config/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBgWnsanynni4RFeex5jaSKGO7qY0m3CwQ",
  authDomain: "onlystats-4df26.firebaseapp.com",
  projectId: "onlystats-4df26",
  storageBucket: "onlystats-4df26.firebasestorage.app",
  messagingSenderId: "685298698669",
  appId: "1:685298698669:web:ee1ebd0a0e0709c2faf924",
  measurementId: "G-3MW96T7DZ5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

export default app;
